/**
 * O5 · Retirement shim for the old tenant-scoped consumer mount `/c/<slug>/*`.
 *
 * The prepaid funnel is Cardmoji-owned and program-resolved at `/create`.
 * Query string (attribution/UTM/referral) is preserved through the redirect.
 */
import { Navigate, useLocation } from "react-router-dom";

export default function LegacyConsumerRedirect() {
  const location = useLocation();
  return <Navigate to={`/create/style${location.search}`} replace />;
}
